import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0083437c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "h"
  }, null, -1);
});
var _hoisted_2 = {
  "class": "lotteryMain"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "aboutBanner mhide"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: "https://00853six.com/assets/about-eab1f5f4.png"
  })], -1);
});
var _hoisted_4 = {
  "class": "sub-nav"
};
var _hoisted_5 = {
  "class": "main-page-full"
};
export default {
  __name: 'us',
  setup: function setup(__props) {
    var toLink = reactive([{
      name: ' 關於我們 ',
      path: '/us'
    }, {
      name: ' 遊戲規範 ',
      path: '/us/rule'
    }, {
      name: ' 獎券規例 ',
      path: '/us/policy'
    }, {
      name: ' 聯繫我們 ',
      path: '/us/contact'
    }]);
    return function (_ctx, _cache) {
      var _component_router_link = _resolveComponent("router-link");
      var _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("nav", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toLink), function (item, index) {
        return _openBlock(), _createBlock(_component_router_link, {
          to: {
            path: item.path
          },
          key: index,
          "active-class": "router-link-exact-active"
        }, {
          "default": _withCtx(function () {
            return [_createElementVNode("span", null, _toDisplayString(item.name), 1)];
          }),
          _: 2
        }, 1032, ["to"]);
      }), 128))])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_router_view)])])], 64);
    };
  }
};